import { NonIdealState, Spinner } from "@blueprintjs/core";
import Padding from "common/fragments/Padding";
import Label from "core/components/label/Label";
import { Component } from "react";
import { FlexJustify } from "../../../../common/fragments/Flex";
import { CardView } from "../../../../common/views/card/Card.view";
import { default as HeadingView, HeadingVariant } from "../../../../common/views/heading/Heading.view";
import { Query } from "../../../../core/api/typedQuery";
import TokenSession from "core/util/session/TokenSession";
import { Followers } from "panels/forum/entity/Followers";

interface IFollowingProps {

}

const SubQuery = Query.queryMany<Followers, any>(Followers);

export default class FollowersPanel extends Component<IFollowingProps> {

	private renderList(users: Followers[]) {
		return users.filter((s) => s.user != null).map((s) =>
			<CardView key={s.id} viewKey="user.sub">
				<Padding.Base>
					<FlexJustify>
						<HeadingView viewKey="user.sub.title" variant={HeadingVariant.H5}>{s.user.firstName} {s.user.lastName}</HeadingView>
					</FlexJustify>
				</Padding.Base>
			</CardView>
		);
	}

	public render() {
		const params = {
			targetUserId: TokenSession.getUserId()
		}

		return (
			<SubQuery params={params}>
				{
					({ data, loading }) => {

						if (loading) {
							return <Spinner />;
						}

						if (!data) {
							return (
								<NonIdealState
									title={<Label k="followers.user.subs.empty" v="No Followers" />}
									description={<Label k="followers.user.subs.empty.desc" v="No Followers" />}
								/>
							);
						}

						return this.renderList(data);
					}
				}
			</SubQuery>
		);
	}

}






// WEBPACK FOOTER //
// ./src/panels/forum/component/subscriptions/FollowersPanel.tsx